<template>
  <div>
    <FileUpload
      :options="{
        allowMultiple: true,
        acceptedFileTypes,
      }"
      v-model="formData.media"
    >
      <template #default="{ handleRemove }">
        <ul class="divide-y divide-gray-200">
          <TemporaryMediaUploadListItem
            v-for="item in formData.media"
            :key="item.id"
            :temporary-media-upload="item"
            :data="formData.included[item.id]"
            :disabled="loading"
            :on-remove="handleRemove"
            @update:data="formData.included[item.id] = $event"
          />
        </ul>
      </template>
    </FileUpload>

    <BaseButton
      primary
      :disabled="loading || formData.media.length === 0"
      @click="storeMedia"
      class="w-full"
    >
      Submit
    </BaseButton>
  </div>
</template>

<script>
import FileUpload from 'Components/FileUpload/Index.vue';
import { projectTaskMediaClient } from '@/api/clients';
import TemporaryMediaUploadListItem from './createMediaAsset/TemporaryMediaUploadListItem.vue';

export default {
  components: {
    FileUpload,
    TemporaryMediaUploadListItem,
  },
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      acceptedFileTypes: [
        'image/*',
        'application/pdf',
        'video/*',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
      formData: {
        media: [],
        included: {},
      },
    };
  },
  methods: {
    async storeMedia() {
      try {
        this.loading = true;
        await projectTaskMediaClient.store(this.taskId, this.formData);

        this.resetFormData();

        this.loading = false;
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    resetFormData() {
      this.formData.media = [];
      this.formData.included = {};
    },
  },
};
</script>
